"use client";

import { useEffect } from "react";
import { useRouter } from "next/router";
import { shouldPreloadStripeForPath } from "@/lib/stripePreloadRoutes";

/** Pages Router: preload Stripe.js for Radar fraud signals on non-embed routes. */
export default function StripeFraudPreloadPages() {
  const router = useRouter();
  useEffect(() => {
    if (!shouldPreloadStripeForPath(router.pathname)) {
      return;
    }
    void import("@/lib/stripeClient").then(({
      preloadStripe
    }) => {
      preloadStripe();
    });
  }, [router.pathname]);
  return null;
}